const UPPERCASE = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWERCASE = 'abcdefghijkmnopqrstuvwxyz';
const NUMBERS = '23456789';
// Matches shared/helpers/Validators.js special char regex set
const SPECIAL = "!@#$%^&*()_+-=[]{}|'\"/\\\\.,`<>:;?~";

function randomInt(max) {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0] % max;
}

function pick(str) {
  return str[randomInt(str.length)];
}

function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = randomInt(i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

/**
 * Generates a strong password satisfying Chatwoot UI validation:
 * - at least 1 uppercase, 1 lowercase, 1 number, 1 special character
 * - default length 16
 */
export function generateStrongPassword({ length = 16 } = {}) {
  const min = 6;
  const targetLength = Math.max(length, min, 4);
  const all = UPPERCASE + LOWERCASE + NUMBERS + SPECIAL;

  // ensure requirements are met
  const chars = [pick(UPPERCASE), pick(LOWERCASE), pick(NUMBERS), pick(SPECIAL)];
  while (chars.length < targetLength) {
    chars.push(pick(all));
  }
  return shuffle(chars).join('');
}

